import {getAuth} from "../modules/auth";
import {API_HOSTNAME_URL} from "../mock/URLs";

export const createChatWebSocket = (
    showBrowserNotification?: (title: string, options?: NotificationOptions | undefined) => void,
) => {
  const token = getAuth()?.access

  const wsUrl =
      `wss://${API_HOSTNAME_URL}/ws/chat/?token=${token}`;

  const socket = new WebSocket(wsUrl);

  socket.onopen = () => {
  };

  socket.onmessage = (event) => {
    const receivedData = JSON.parse(event.data);
    const title = `${receivedData?.sender?.first_name} ${receivedData?.sender?.last_name}` || "Anonymous";
    const body = receivedData?.message || "Yangi xabar";

    showBrowserNotification && showBrowserNotification(title, {
      body
    })
  };

  socket.onclose = () => {};
  socket.onerror = (error) => {};

  return {socket};
};
